import React, { useState } from 'react';
import './Contact.css';
import { FaInstagram, FaYoutube, FaLinkedin } from 'react-icons/fa';

const Contact = () => {
  const [isSent, setIsSent] = useState(false);
  const [status, setStatus] = useState('');

  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    const formData = new FormData(e.target);

    const res = await fetch("https://formspree.io/f/xvgqwjlp", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    if (res.ok) {
      setIsSent(true);
      setStatus('✅ Message sent successfully!');
      e.target.reset();
    } else {
      setStatus('❌ Something went wrong. Try again.');
    }
  };

  return (
    <section className="contact-section" id="contact">
      <h2 className="section-title">Get In <span>Touch</span></h2>
      <p className="section-subtitle">
        Have a project in mind or want to collaborate? Feel free to reach out to me.
      </p>

      <div className="contact-wrapper">
        {/* LEFT SIDE INFO */}
        <div className="contact-left">
          <div className="info-block">
            <h4>📧 Email</h4>
            <p>workwithsundaram@gmail.com</p>
          </div>
          <div className="info-block">
            <h4>📞 Phone</h4>
            <p>+91 8530348748</p>
          </div>
          <div className="info-block social-icons">
            <a href="https://www.instagram.com/iamthelocalfilmmaker/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/@sundaram_tarone" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/in/sundaram-tarone-521389271/" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
          </div>
          <div className="info-block">
            <h4>📅 Availability</h4>
            <p>
              I’m currently available for freelance projects and collaborations.
              Let’s create something amazing together!
            </p>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="contact-right">
          <form onSubmit={sendEmail} className="contact-form">
            <label>Your Name *</label>
            <input type="text" name="name" placeholder="Enter your full name" required />
            <label>Email Address *</label>
            <input type="email" name="email" placeholder="youremail@example.com" required />
            <label>Subject *</label>
            <input type="text" name="subject" placeholder="What's this about?" required />
            <label>Your Message *</label>
            <textarea name="message" placeholder="Tell me about your project or idea..." rows="5" required></textarea>
            <button type="submit">🚀 Send Message</button>
            {status && <p className={isSent ? 'success-msg' : 'error-msg'}>{status}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
